import { Table } from 'dexie';
import db, { DataRepository, Database, Key } from '@/db';
import { HeadTypeFamily } from '../../api/models';

export type TABLE_TYPE = Table<HeadTypeFamily>;

export const TABLE = 'headTypeFamily';
const SCHEMA = 'headTypeFamilyId';

class HeadTypeFamilyDatabase implements DataRepository<HeadTypeFamily> {
  constructor(private db: Database) {
    db.registerModelSchema(TABLE, SCHEMA);
  }

  get(key: Key): Promise<HeadTypeFamily | undefined> {
    return this.db[TABLE].get(key);
  }

  delete(key: Key): Promise<void> {
    return this.db[TABLE].delete(key);
  }

  update(payload: HeadTypeFamily, key: Key): Promise<HeadTypeFamily> {
    return this.db[TABLE].put(payload, key);
  }

  bulkAdd(payload: HeadTypeFamily[]): Promise<HeadTypeFamily[]> {
    return this.db[TABLE].bulkPut(payload);
  }

  list(): Promise<HeadTypeFamily[]> {
    return this.db[TABLE].toArray();
  }
}

export const HeadTypeFamilyDB = new HeadTypeFamilyDatabase(db);
